import React, { useEffect, useContext, useState } from 'react';
import message from 'antd/lib/message';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { useQuery } from 'react-query';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import { FirebaseContext } from '../../context/FirebaseContext';
import LoadingAnimation from '../../components/LoadingAnimation';
import SearchableImput from '../../NecttosComp/Input/SearchableImput';
import { Body, Header, Main } from '../../NecttosComp/Layout/Layout';
import Button from '../../NecttosComp/Button/Button';
import Input2 from '../../NecttosComp/Input/Input2';

const getDDCSubjects = (collegeId, key) => async () => {
	const instance = await getAxiosTokenInstance();
	try {
		const resp = await instance.get('/college/action/getDDCSubjects', {
			params: { collegeId, key },
		});

		if (resp.data.statusCode === 400) {
			throw new Error(resp.data.message || 'API Error');
		} else {
			return resp?.data?.list;
		}
	} catch (error) {
		throw new Error(error?.response?.data?.message || error.message || 'API Error');
	}
};

const getSubjects = (collegeId, key) => async () => {
	const instance = await getAxiosTokenInstance();
	try {
		const resp = await instance.get('/college/action/getSubjects', {
			params: { collegeId, key },
		});

		if (resp.data.statusCode === 400) {
			throw new Error(resp.data.message || 'API Error');
		} else {
			return resp?.data?.list;
		}
	} catch (error) {
		throw new Error(error?.response?.data?.message || error.message || 'API Error');
	}
};

function EditBook({ onSuccess, stockId, onCloseModal, editableData, refectOrgin }) {
	const { collegeId } = useContext(FirebaseContext);
	const [stateData, setStateData] = React.useState({});
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		if (stockId) {
			handleISBNSearch();
		}
	}, [stockId]);

	const handleISBNSearch = async () => {
		try {
			const instance = await getAxiosTokenInstance();
			const resp = await instance.get(`/college/library/getBookDetails?stockId=${stockId}`);
			if (resp.data.statusCode === 400) {
				throw new Error(resp.data.message || 'API Error');
			}
			if (resp.data.statusCode === 200) {
				console.log({ resp });
				setStateData(resp.data.bookDetails);
			}
		} catch (err) {
			console.log(err);
			message.error('No books found');
		}
	};

	const halndeDelete = async () => {
		try {
			const instance = await getAxiosTokenInstance();
			let resp;
			resp = await instance.post('/college/libraryOld/deleteBook', {
				collegeId,
				stockId,
			});
			if (resp.data.statusCode !== 200) {
				throw new Error(resp.data.message || 'API Error');
			} else {
				onCloseModal();
				refectOrgin();
			}
		} catch (error) {
			message.error(error?.response?.data?.message || error?.message || 'API Error');
		}
	};

	const { data: subjects = [] } = useQuery(['SubjectDrops'], getSubjects(collegeId), { keepPreviousData: true });

	const { data: ddcDrops = [] } = useQuery(['ddcDrops', stateData?.subject], getDDCSubjects(collegeId, stateData?.subject), { keepPreviousData: true });

	const handleFileChange = (e) => {
		const file = e.target.files[0];
		if (file) {
			const url = URL.createObjectURL(file);
			setStateData({ ...stateData, image: file, previewUrl: url });
		}
	};

	const manageSubject = async (e) => {
		e.preventDefault();
		try {
			setIsLoading(true);
			let newImage = stateData?.image;
			const instance = await getAxiosTokenInstance();

			if (newImage instanceof File) {
				const storage = getStorage();
				const logoImagesRef = ref(storage, `books/smc/${stateData?.bookId}/coverPhoto.png`);
				const buffer = await newImage.arrayBuffer();
				await uploadBytes(logoImagesRef, buffer, {
					contentType: 'image/png',
				});
				newImage = await getDownloadURL(logoImagesRef);
				setStateData({ ...stateData, image: newImage });
			}

			let resp;
			resp = await instance.post('/college/libraryOld/editBook', { collegeId, ...stateData, image: newImage });
			if (resp.data.statusCode !== 200) {
				throw new Error(resp.data.message || 'API Error');
			} else {
				onSuccess();
			}
		} catch (error) {
			message.error(error?.response?.data?.message || error?.message || 'API Error');
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<>
			{isLoading ? (
				<div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center'>
					<LoadingAnimation />
				</div>
			) : (
				<Main title='Edit Book' className='h-[100%] w-[100%] bg-white z-10 rounded-xl overflow-hidden flex flex-col '>
					<Header className='flex justify-between items-center px-4 py-2'>
						<div className='text-lg font-semibold text-gray-800 dark:text-gray-50'>Edit Book</div>
						<div className='flex items-center gap-2'>
							<Button onClick={handleISBNSearch} type='search'>
								Load Selected Book Data
							</Button>

							<Button onClick={halndeDelete} type='close' className='h-10 w-[120px] rounded-3xl'>
								Delete
							</Button>

							<Button onClick={onCloseModal} type='close' className='h-10 w-[120px] rounded-3xl'>
								Cancel
							</Button>

							<Button onClick={manageSubject} type='save'>
								Save
							</Button>
						</div>
					</Header>

					<Body className='flex-1 overflow-hidden'>
						<form onSubmit={manageSubject} className='flex flex-col h-full w-full p-4'>
							<div className='grid grid-cols-4 gap-3 w-full h-full'>
								<div className='bg-slate-100 dark:bg-neutral-700  p-3 rounded-xl shadow-md flex flex-col gap-2'>
									<SearchableImput keyData='isbn' titleData='ISBN' collection='books' stateData={stateData} setStateData={setStateData} />
									<SearchableImput keyData='nameOfBook' titleData='Title of Book' collection='books' stateData={stateData} setStateData={setStateData} />
									<div className='flex gap-1'>
										<SearchableImput keyData='nameOfAuthor' titleData='First Author' collection='books' stateData={stateData} setStateData={setStateData} />
										<SearchableImput keyData='authorType' titleData='Type' collection='books' stateData={stateData} setStateData={setStateData} />
									</div>
									<div className='flex gap-1'>
										<SearchableImput keyData='nameOfAuthor2' titleData='Second Author' collection='books' stateData={stateData} setStateData={setStateData} />
										<SearchableImput keyData='authorType2' titleData='Type' collection='books' stateData={stateData} setStateData={setStateData} />
									</div>
									<div className='flex gap-1'>
										<SearchableImput keyData='nameOfAuthor3' titleData='Third Author' collection='books' stateData={stateData} setStateData={setStateData} />
										<SearchableImput keyData='authorType3' titleData='Type' collection='books' stateData={stateData} setStateData={setStateData} />
									</div>
									<Input2 type='drop' fieldName='Subject' returnKey='subject' state={stateData} setState={setStateData} options={subjects?.map((item) => ({ name: item }))} optionDisplay='name' optionKey='name' className='w-full' />
									<Input2
										type='drop'
										fieldName='DDC Subject'
										returnKey='ddcSubject'
										state={stateData}
										setState={(val) => {
											const ddcNumber = ddcDrops?.find((x) => x?.ddcSubject === val.ddcSubject)?.ddcNumber;
											setStateData({
												...stateData,
												ddcSubject: val.ddcSubject,
												ddcNumber,
												callNo: `${ddcNumber} ${stateData?.nameOfAuthor?.toUpperCase()?.slice(0, 3)}/${stateData?.nameOfBook?.toUpperCase()?.slice(0, 1)}`,
											});
										}}
										options={ddcDrops?.map((item) => ({
											ddcSubject: item.ddcSubject,
											name: `${item.ddcNumber} - ${item.ddcSubject}`,
										}))}
										optionDisplay='name'
										optionKey='ddcSubject'
										className='w-full'
									/>
									<SearchableImput keyData='nameOfPublisher' titleData='Publisher' collection='books' stateData={stateData} setStateData={setStateData} />
									<SearchableImput keyData='placeOfPublication' titleData='Place' collection='books' stateData={stateData} setStateData={setStateData} />
									<Input2 type='number' fieldName='Year of Publication' returnKey='yearOfPublication' state={stateData} setState={setStateData} />
								</div>

								<div className='bg-slate-100 dark:bg-neutral-700 p-3 rounded-xl shadow-md flex flex-col gap-2'>
									<Input2 type='text' fieldName='Call Number' returnKey='callNo' state={stateData} setState={setStateData} />
									<Input2 type='text' fieldName='Edition' returnKey='edition' state={stateData} setState={setStateData} />
									<Input2 type='text' fieldName='Volume' returnKey='volume' state={stateData} setState={setStateData} />
									<Input2 type='text' fieldName='Series' returnKey='series' state={stateData} setState={setStateData} />
									<Input2 type='number' fieldName='Pages' returnKey='pages' state={stateData} setState={setStateData} />
									<Input2 type='number' fieldName='Actual Price' returnKey='price' state={stateData} setState={setStateData} />
									<Input2 type='number' fieldName='Discount Price' returnKey='discount' state={stateData} setState={setStateData} />
									<Input2 type='text' fieldName='Invoice Number' returnKey='invoiceNumber' state={stateData} setState={setStateData} />
									<Input2 type='date' fieldName='Invoice Date' returnKey='date' state={stateData} setState={setStateData} />
									<SearchableImput keyData='vendor' titleData='Vendor' collection='bookStocks' stateData={stateData} setStateData={setStateData} />
									<SearchableImput keyData='fund' titleData='Fund' collection='bookStocks' stateData={stateData} setStateData={setStateData} />
								</div>

								<div className='bg-slate-100 dark:bg-neutral-700 p-3 rounded-xl shadow-md flex flex-col gap-2'>
									<SearchableImput keyData='category' titleData='Category' collection='bookStocks' stateData={stateData} setStateData={setStateData} />
									<SearchableImput keyData='language' titleData='Language' collection='books' stateData={stateData} setStateData={setStateData} />
									<Input2 type='number' fieldName='Accession Number' returnKey='accessionNumber' state={stateData} setState={setStateData} />
									<SearchableImput keyData='status' titleData='Status' collection='bookStocks' stateData={stateData} setStateData={setStateData} />

									<div className='mt-4 bg-slate-100 dark:bg-neutral-700 rounded-lg border border-gray-300 dark:border-slate-400 p-4 shadow-sm w-full'>
										<Input2 type='textarea' fieldName='Contents' returnKey='contents' state={stateData} setState={setStateData} className='w-full mb-4 min-h-[130px]' inputClass='w-full h-full bg-transparent p-2.5 text-[#006711] font-sans font-semibold text-base border-none focus:outline-none rounded-xl' labelClass='text-xs font-semibold text-[#006711] opacity-70 mb-1 block' />

										<Input2 type='textarea' fieldName='Remarks' returnKey='bookDetails' state={stateData} setState={setStateData} className='w-full min-h-[130px]' inputClass='w-full h-full bg-transparent p-2.5 text-[#006711] font-sans font-semibold text-base border-none focus:outline-none rounded-xl' labelClass='text-xs font-semibold text-[#006711] opacity-70 mb-1 block' />
									</div>
								</div>

								<div className='bg-slate-100 dark:bg-neutral-700 p-3 rounded-xl shadow-md flex flex-col justify-center items-center'>
									<label className='cursor-pointer w-full text-center'>
										<input type='file' className='hidden' onChange={handleFileChange} accept='image/png' />
										<img src={stateData.previewUrl ? stateData.previewUrl : stateData.image} alt='Uploaded Preview' className='h-[260px] w-auto object-contain mx-auto' />
										<div className='text-sm text-gray-500 mt-2'>Click image to change</div>
									</label>
								</div>
							</div>
						</form>
					</Body>
				</Main>
			)}
		</>
	);
}

export default EditBook;
